import { render, staticRenderFns } from "./FcValues.vue?vue&type=template&id=fcb47744&scoped=true"
import script from "./FcValues.vue?vue&type=script&lang=js"
export * from "./FcValues.vue?vue&type=script&lang=js"
import style0 from "./FcValues.vue?vue&type=style&index=0&id=fcb47744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb47744",
  null
  
)

export default component.exports